export const formatNumber = (number) => {
  if(typeof number === 'number' || typeof number === 'string'){
    const formatter = new Intl.NumberFormat("pt-BR")
    return formatter.format(number);
  }
  else {
    return 0
  }
}